interface GiftCardErrorMessageMap {
  [key: string]: string;
  zeroBalance: string;
}

const GiftCardErrorMessage: GiftCardErrorMessageMap = {
  zeroBalance:
    'The giftcard you entered was not able to be redeemed due to a low balance.  Please check your reference/code and password.',
  invalidGiftcard:
    'The giftcard you entered was not able to be redeemed.  Please check your reference/code and password.',
  insufficentBalance:
    'The giftcard you entered was not able to be redeemed due to a low balance.  Please check your reference/code and password.',
  maxLimitError:
    'Unfortunately, you have reached the maximum number of giftcards allowed for payment. Please continue by using a different payment method.',
  unexpectedError:
    'Unfortunately, we were unable to take payment for this order and no payment has been taken. Please review your chosen payment methods.',
};

export default GiftCardErrorMessage;
